var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "CardBase",
        [
          _c(
            "MacroSubHeader",
            { attrs: { title: "Banners", icon: "el-icon-picture-outline" } },
            [
              _c(
                "template",
                { slot: "actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.openModal }
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus" }),
                      _vm._v(
                        "\n                    Adicionar\n                "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            2
          ),
          _vm._v(" "),
          _c("CardBase", [_c("BannerList", { ref: "bannerList" })], 1)
        ],
        1
      ),
      _vm._v(" "),
      _c("BannerCreateModal", {
        ref: "bannerCreateModal",
        on: { created: _vm.handleDispatch }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8d7f01a8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d7f01a8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_internal/configuracoes/banner/Index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-8d7f01a8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_internal/configuracoes/banner/Index.vue
// module chunks = 2